// Pricing data
export const automatedPriceMonthly = {
    "200": { price: 49, webinars: 2, storage: "2 GB" },
    "500": { price: 79, webinars: 2, storage: "5 GB" },
    "3000": { price: 197, webinars: 4, storage: "10 GB" },
    "6000": { price: 299, webinars: 4, storage: "10 GB" },
    "10000": { price: 449, webinars: 6, storage: "10 GB" },
    "10000+": { price: "**", webinars: "6+", storage: "Custom" }
};

export const automatedPriceYearly = {
    "200": { price: 41, webinars: 2, storage: "2 GB" },
    "500": { price: 66, webinars: 2, storage: "5 GB" },
    "3000": { price: 164, webinars: 4, storage: "10 GB" },
    "6000": { price: 249, webinars: 4, storage: "10 GB" },
    "10000": { price: 374, webinars: 6, storage: "10 GB" },
    "10000+": { price: "**", webinars: "6+", storage: "Custom" }
};

export const allInOnePriceMonthly = {
    "100": { price: 49, webinars: 3, storage: "2 GB" },
    "300": { price: 79, webinars: 3, storage: "5 GB" },
    "1000": { price: 197, webinars: 3, storage: "10 GB" },
    "3000": { price: 299, webinars: 6, storage: "10 GB" },
    "6000": { price: 449, webinars: 6, storage: "10 GB" },
    "6000+": { price: "**", webinars: "6+", storage: "Custom" }
};

export const allInOnePriceYearly = {
    "100": { price: 41, webinars: 3, storage: "2 GB" },
    "300": { price: 66, webinars: 3, storage: "5 GB" },
    "1000": { price: 164, webinars: 3, storage: "10 GB" },
    "3000": { price: 249, webinars: 6, storage: "10 GB" },
    "6000": { price: 374, webinars: 6, storage: "10 GB" },
    "6000+": { price: "**", webinars: "6+", storage: "Custom" }
}; 